<!--付款成功页-->
<template>
  <div
    class="resultStatus resultSuccess full-width full-height flex column justify-center text-center q-px-lg"
    :class="{
      scheduledPickup:
        detail && detail.scheduled && detail.serviceType === 'PICK_UP',
    }"
  >
    <template v-if="shipmentStatusCode">
      <template v-if="isSuccessDELIVERY">
        <div class="title font-size-20 text-weight-bolder statuscode-box">
          <div>
            <strong v-html="orderMsgs.status" />
          </div>
          <div>
            <strong> {{ orderMsgs.Driver }}</strong>
          </div>
          <div>
            <strong> {{ orderMsgs.Seller }}</strong>
          </div>
        </div>
        <div class="YourMeal-box">
          <div
            class="desc font-size-16 text-theme-gray q-py-sm statuscode-value"
          >
            <span v-html="orderMsgs.value" />
          </div>
          <div
            v-if="orderMsgs.CourierInfo"
            class="desc font-size-16 text-theme-gray q-py-sm CourierInfo"
          >
            <span> {{ orderMsgs.CourierInfo }}</span>
          </div>
          <div v-if="isRiderToBuyer" class="text-theme-gray q-py-sm GKNumber">
            <span> {{ shipmentExternalId }}</span>
          </div>
        </div>

        <div class="CheckDetails">
          <span @click="alterCheck">{{ $t('result.showDetilStatus1') }}</span>
          <!-- <q-img
            src="~assets/icons/svg/icon/ChevronRight.svg"
            style="width: 16px;height: 20px;"
          /> -->
          <span class="iconfont">&#xe744;</span>
        </div>
      </template>
      <div v-if="serviceTypeStatus !== 'DELIVERY'">
        <div v-if="paymentMethodType !== 'CASH'">
          <div class="title font-size-20 text-weight-bolder">
            {{ $t('result.successDineInTitle2') }}
          </div>
          <div class="desc font-size-16 text-theme-gray q-my-sm q-mt-md">
            {{ $t('result.successDineInDesc1') }}
          </div>
          <div class="font-size-16 text-weight-bolder q-mt-md">
            {{
              isApartDine
                ? STORE_TABLE
                : detail.serviceType === 'DINE_IN'
                ? $t('result.successDineInTableNumber1', [STORE_TABLE])
                : $t('result.successDineInTableNumber2')
            }}
          </div>
        </div>
        <div v-if="paymentMethodType === 'CASH'">
          <div class="title font-size-20 text-weight-bolder">
            {{ $t('result.successCashTitle') }}
          </div>
          <div
            class="desc font-size-16 text-theme-gray q-my-sm q-mt-md"
            v-html="$t('result.successCashDesc')"
          />
          <div class="font-size-16 text-weight-bolder q-mt-md">
            {{
              isApartDine
                ? STORE_TABLE
                : detail.serviceType === 'DINE_IN'
                ? $t('result.successDineInTableNumber1', [STORE_TABLE])
                : $t('result.successDineInTableNumber2')
            }}
          </div>
        </div>
        <div
          class="number text-weight-bolder font-size-60 q-mt-md"
          :class="{ 'apart-area-address': isApartDine }"
        >
          {{ getNumber }}
        </div>
      </div>
    </template>
    <SchedPick
      v-if="detail && detail.scheduled && detail.serviceType === 'PICK_UP'"
      :start-time="scheduledStartDate"
      :end-time="scheduledEndDate"
    />
    <Popup :service-type="serviceTypeStatus" @setPopupChild="setPopupChild" />
  </div>
</template>

<script>
// import { getOrderInfo } from 'src/api/order.js';
import orderMixins from 'pages/mixin/orderMixins.js';
import Popup from './Popup.vue';
import { formatDate } from '../../utils/base';
import SchedPick from './components/SchedPick.vue';

export default {
  components: {
    Popup,
    SchedPick,
  },
  mixins: [orderMixins],
  props: {
    mealCode: {
      type: String,
      default: '',
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      code: this.mealCode,
      timer: null,
      paymentMethodType: '',
      serviceTypeStatus: '',
      shipmentStatusCode: '',
      shipmentExternalId: '',
      details: [],
      scheduledStartDate: '',
      scheduledEndDate: '',
    };
  },
  computed: {
    getNumber() {
      if (this.detail.serviceType === 'DINE_IN') {
        return this.detail.tableNumber;
      }

      return this.mealCode ? this.mealCode : this.$route.query.serialNumber;
    },
    STORE_TABLE() {
      return this.$t(`list.table${this.storeInfo.businessType}`);
    },
    isDine() {
      return this.detail.serviceType === 'DINE_IN';
    },
    isPick() {
      return this.detail.serviceType === 'PICK_UP';
    },
    isApartDine() {
      return this.isApartment && this.isDine;
    },
  },
  watch: {
    detail: {
      handler(val) {
        val = val || {};
        this.serviceTypeStatus = val.serviceType;
        if (val.scheduledEndDate) {
          this.scheduledStartDate = formatDate(
            val.scheduledDate?.dbStamp,
            'EEE, dd MMMM, HH:mm',
          );
          this.scheduledEndDate = formatDate(
            val.scheduledEndDate?.dbStamp,
            'HH:mm',
          );
        }

        if (val.shipment) {
          this.shipmentStatusCode = val.shipment.trackingStatusCode;
          this.paymentMethodType = val.payments[0].paymentMethodTypeId;
          this.shipmentExternalId = val.shipment.externalId;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 历史记录 插入当前界面
      window.history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }

    const { currentRoute } = this.$router;
    this.$store.dispatch('prefetch/prefetchStoreInfo', { currentRoute });
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
    setPopupChild(child) {
      this.popupChild = child;
    },
    alterCheck() {
      if (this.popupChild) {
        this.popupChild.alert = true;
      }
    },
    goBack() {
      window.history.pushState(null, null, document.URL);
    },
  },
};
</script>

<style lang="scss" scoped>
.resultSuccess {
  background: url('~src/assets/images/result/successBg.png') no-repeat center;
  background-size: cover;
  .title {
    color: #ff9e2d;
    line-height: 120%;
  }
  .desc {
    line-height: 16px;
  }
  .number {
    line-height: 100%;
  }
}
.scheduledPickup {
  padding-bottom: 46px !important;
}
// //delivery
.YourMeal {
  color: #6b7280;
  font-weight: normal;
}
.Thank-courier > div {
  color: #6b7280;
  font-weight: normal;
}
.CheckDetails {
  margin-top: 16px;
  font-weight: bold;
  color: $primary;
  font-size: 12px;
  .iconfont {
    vertical-align: middle;
  }
}

.statuscode-box {
  color: #ff9e2d;
}
.statuscode-value {
  color: #6b7280;
}

.CourierInfo {
  color: $black;
}
.urierInfo {
  color: $black;
}
.GKNumber {
  font-size: 36px;
  color: $black;
  font-weight: bold;
}
.scheduled {
  background: #f3f4f6;
}
</style>
